import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {StyledButton, StyledCard, StyledTag} from "./Orders.styled";
import {Button, Col, Flex, Tag} from "antd";
import style from "./Orders.module.scss";
import {ApprovedRequestCardProps, OrdersCardProps} from "../../models";
import { MdGroups } from "react-icons/md";
import {FaClock} from "react-icons/fa";


const OrdersCard = ({detail}:OrdersCardProps) => {
    return (
        <StyledCard>
            <Flex align={"center"} justify={"space-between"}>
                <Col xs={7} sm={7} md={6} lg={8} xl={8}>
                    <img className={style.customImg} src={require("assets/Logo/ad2.png")} width={23} height={15}/>
                </Col>
                <Col xs={16} sm={16} md={17} lg={8} xl={8}>
                    <Flex vertical justify={"space-between"}>
                        <Flex justify={"start"}>
                           <span className={style.requestDetailApproved}>
                            <FaClock /> {detail.timeLeft}</span>
                        </Flex>
                        <Flex justify={"start"}>
                            <span className={style.requestDetailTitle}>{detail?.title}</span>
                        </Flex>

                        <Flex justify={"space-between"} align={"center"}>
                            <Flex vertical gap={"small"}>
                                <span
                                    className={style.requestDetailText}>از تاریخ <StyledTag>{detail?.fromDate}</StyledTag></span>
                                <span
                                    className={style.requestDetailText}>تا تاریخ <StyledTag>{detail?.toDate}</StyledTag></span>
                            </Flex>
                            <Flex vertical gap={"small"} justify={"center"} align={"center"}>
                                <Flex justify={"center"} align={"center"} gap={"small"}>
                                    <StyledButton type={'primary'}  size={"small"}>تمدید قراداد</StyledButton>
                                    <StyledButton  size={"small"}>لغو سفارش</StyledButton>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Flex>
                </Col>
            </Flex>
        </StyledCard>
    );
};

export default connect(null, {})(
    withRouter(OrdersCard)
);
